<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
              <h3 class="d-inline heading">Student's Assessment</h3>
          </div>
          <div class="heading-seperator"></div>

          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-if="loading === false">
            <div class="row tasklist-wrapper">
              <div class="mx-auto col-md-12">
                <div class="text-align-center mentee_name">
                  Student : {{ menteeName }}
                </div>
                <hr style="width:50%;">
              </div>
            </div>
            <div v-if="tasklists.length > 0">
              <div class="row">
                <div class="col-md-6 col-sm-9 col-9 mx-auto">
                  <b-form-select v-model="tasklistId" :options="tasklists" style="margin-bottom: 0px !important" class="mb-3 col-md-12" @change="showAssessmentofTasklist()" />
                </div>
              </div>
              <div v-show="tasklists_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
              <div class="col-md-12 counter_subtask-list" id="tasks">
                <div v-for = "(subtask, stindex) in subtasks">
                  <div class="subtask-wrapper">
                    <h4 class="panel-title">
                      <b-link v-b-toggle="'collapse-' + subtask.id">
                        <span class="counter_subtask-list__counter"></span>
                        {{ subtask.name }}
                      </b-link>
                    </h4>
                    <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper">
                      <b-card>
                        <div class="col-md-12 override-padding counter_heading-list">
                          <div v-for = "(heading, index) in subtask.headings">
                            <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id" size="sm" class="sub-heading">
                              <span class="counter_heading-list__counter"></span>
                              {{ heading.name }}
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </b-link>
                            <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                              <div class="col-md-12 override-padding counter_task-list">
                                <div v-for = "task in heading.tasks">
                                  <b-card @click="openHistoryModal('' + task.id + '')" class="float-left d-none d-md-block d-lg-block modal-task">
                                    <div class="task-title">
                                      <span class="counter_task-list__counter"></span>
                                      {{ task.description }}
                                    </div>
                                    <div class="other-account-task-score" data-toggle="tooltip" title="Mentor Score" v-if="task.instructor_score">
                                      {{ task.instructor_score }}
                                    </div>
                                    <div class="task-score" data-toggle="tooltip" title="Score" v-if="task.score">
                                      {{ task.score }}
                                    </div>
                                  </b-card>

                                  <b-card v-bind:id="task.id" class="float-left d-block d-sm-block d-md-none">
                                    <div>
                                      <div class="task-title">
                                        <span class="counter_task-list__counter"></span>
                                        {{task.description}}
                                      </div>
                                      <div class="other-account-task-score" v-if="task.instructor_score">
                                        {{ task.instructor_score }}
                                      </div>
                                      <div class="task-score" v-if="task.score">
                                        {{ task.score }}
                                      </div>
                                    </div>
                                    <div class="comment-icon-wrapper" v-if="task.score">
                                      <router-link v-bind:to="'/task-assessment-view/' + menteeId + '/' + task.id + '/' + tasklistId + '@' + heading.id + '@' + subtask.id + ''">
                                        <i class="fa fa-comment"></i><span class="view-comment">Comments</span>
                                      </router-link>
                                    </div>
                                  </b-card>
                                </div>
                                <div style="clear: both;"></div>
                              </div>
                            </b-collapse>
                          </div>
                        </div>
                        <div class="col-md-12 override-padding counter_task-list">
                          <div v-for = "substasklisttask in subtask.tasks" class="task-wrapper">
                            <b-card @click="openHistoryModal('' + substasklisttask.id + '')" class="float-left d-none d-md-block modal-task">
                              <div class="task-title">
                                <span class="counter_task-list__counter"></span>
                                {{ substasklisttask.description }}
                              </div>
                              <div class="other-account-task-score" data-toggle="tooltip" title="Mentor Score" v-if="substasklisttask.instructor_score">
                                {{ substasklisttask.instructor_score }}
                              </div>
                              <div class="task-score" data-toggle="tooltip" title="Score" v-if="substasklisttask.score">
                                {{ substasklisttask.score }}
                              </div>
                            </b-card>

                            <b-card v-bind:id="substasklisttask.id" class="float-left d-block d-sm-block d-md-none">
                              <div class="task-title">
                                <span class="counter_task-list__counter"></span>
                                {{ substasklisttask.description }}
                              </div>
                              <div class="other-account-task-score" v-if="substasklisttask.instructor_score">
                                {{ substasklisttask.instructor_score }}
                              </div>
                              <div class="task-score"  v-if="substasklisttask.score">
                                {{ substasklisttask.score }}
                              </div>
                              <div class="comment-icon-wrapper" v-if="substasklisttask.score">
                                <router-link v-bind:to="'/task-assessment-view/' + menteeId + '/' + substasklisttask.id + '/' + tasklistId + '@' + 'null' + '@' + subtask.id + ''">
                                  <i class="fa fa-comment"></i><span class="view-comment">Comments</span>
                                </router-link>
                              </div>
                            </b-card>
                          </div>
                        </div>
                        <div style="clear: both;"></div>
                      </b-card>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="noitems-custom-msg">No tasklist assigned for this student</div>
          </div>
        </div>
        <custommodal :isModalVisible="isModalVisible" @close="isModalVisible = false">
           <div slot="header" class="sub-heading">{{history_title}}</div>
           <div slot="body">
             <div class="history-table-wrapper">
               <table class="generic-list">
                 <thead>
                   <tr>
                       <th class="date">DATE</th>
                       <th class="score">SCORE</th>
                       <th class="comment">COMMENT</th>
                       <th class="postedby">COMMENTED BY</th>
                   </tr>
                 </thead>
                 <div v-show="assessment_loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                 <template v-for = "history in history_comment">
                    <tr>
                    <td>{{history.createdAt | formatDate}}</td>
                    <td>{{history.score}}</td>
                     <td>{{history.comment}}</td>
                     <td>{{history.mentor_name}}</td>
                     </tr>
                   </template>
                  <template v-if="history_comment.length == 0 && assessment_loading == false">
                    <tr >
                      <td colspan="4">No Assessments Found.</td>
                    </tr>
                 </template>
               </table>
             </div>
           </div>
         </custommodal>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import custommodal from '../manager/custom_modal.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
  data: function () {
    return {
      'subtasks': [],
      isModalVisible: false,
      'history_title': '',
      'history_comment': '',
       loading: false,
       tasklists: [],
       tasklistId: '',
      'menteeId': '',
       menteeName: '',
       'assessment_loading': false,
       admin: false,
       tasklists_loading: false,
    }
  },
  methods: {
  openHistoryModal(taskId) {
    this.isModalVisible = true;
    this.assessment_loading = true;
    this.history_comment = '';
    this.history_title = '';
    axios.get('/assessment', {
      params: {
        mentee_id: this.menteeId,
        task_id: taskId,
        tasklist_id: this.tasklistId,
      }
    })
    .then(response =>  {
      this.history_title = response.data.task.description;
      this.history_comment = response.data.history;
      this.assessment_loading = false;
    })
    .catch(function(error) {

    });
  },
  showAssessmentofTasklist() {
    this.tasklists_loading = true;
    this.subtasks = [];
     axios.get('/desktop/mentees_tasklists_detail/' + this.menteeId + '/' + this.tasklistId + '/' + this.$store.state.user_accountid)
      .then(response =>  {
          this.tasklists_loading = false;
          this.subtasks = response.data.subtasks;
          const mentee = response.data.mentee;
      })
      .catch(function(error) {
          
      });
  },
  getMenteeName() {
     axios.get('/user_name/' + this.menteeId, {

     })
     .then(response =>  {
         this.menteeName = response.data;
     })
     .catch(function(error) {

     });
  },
  },
  components: {
    UserMenu,
    GoBack,
    custommodal,
    AdminSidebarMenu
  },
  created: function () {
    this.loading = true;
    this.menteeId = this.$route.params.mentee_id;
    axios.get('/desktop/mentees_tasklists', {
      params: {
        mentee_id: this.menteeId,
        account_id: this.$store.state.user_accountid
      }
    })
    .then(response =>  {
      this.getMenteeName();
      this.loading = false;
      var tasklistArr = response.data;
      this.tasklistId = tasklistArr[0]['id'];
      for( var i=0; i< tasklistArr.length; i++) {
        var tasklistOption = {value:tasklistArr[i]['id'], text:tasklistArr[i]['name']};
        this.tasklists.push(tasklistOption);
      }
      var e4_val = this.$route.query.e4;
      if(typeof(e4_val) !==  "undefined") {
          this.tasklistId = e4_val;
      }
      this.showAssessmentofTasklist()
    })
    .catch(function(error) {

    });
    var roles = store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }

  },

  updated() {
   setTimeout(()=>{
    var e1_val = this.$route.query.e1;
    var e2_val = this.$route.query.e2;
    var e3_val = this.$route.query.e3;
    if(e1_val) {
      var ele = document.getElementById("collapse-" + e1_val);
      ele.style.display = 'block';
      var ele2 = ele.parentElement.getElementsByClassName("panel-title")[0].getElementsByTagName("a")[0];
      ele2.className = '';
      var ele1 = document.getElementById("collapse-" + e1_val + "-" + e2_val);
      ele1.style.display = 'block';
      document.getElementById(e3_val).scrollIntoView(false);
    }
   }, 300);
  },

}
</script>

<style scoped>
.back-btn-wrapper {
  width:100%;
  margin-left: 10px;
  margin-right: 0px;
}
.mentee_name {
    font-size: 20px;
    margin-bottom: 0px;
}
hr {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/students_task.vue